@use '../../design-tokens/typography/typography-variant-classes' as *;

@layer design-system {
  .root {
    margin: 0;
  }

  @include typography-variant-classes;

  .fontRobotoMono {
    font-family: var(--font-roboto-mono);
  }

  .colorDefault {
    color: var(--text-default);
  }

  .colorSoft {
    color: var(--text-soft);
  }

  .colorDisabled {
    color: var(--text-disabled);
  }

  .colorInverse {
    color: var(--text-inverse);
  }

  .colorPrimary {
    color: var(--text-primary);
  }

  .colorSuccess {
    color: var(--text-success);
  }

  .colorWarning {
    color: var(--text-warning);
  }

  .colorCritical {
    color: var(--text-critical);
  }

  .colorLink {
    color: var(--text-link);
  }
}
